export const remediationRules = [
  {
    id: "RR001",
    triggerEvent: "Clicked Link",
    riskScoreDelta: +15,
    assignedModuleId: "TM010",
    notifyLearner: true,
    notifyManager: false,
    notifyAdmin: false,
    dueDays: 3,
    label: "Link Click",
    severity: "medium",
  },
  {
    id: "RR002",
    triggerEvent: "Submitted Credentials",
    riskScoreDelta: +25,
    assignedModuleId: "TM001",
    notifyLearner: true,
    notifyManager: true,
    notifyAdmin: true,
    dueDays: 1,
    label: "Credential Submission",
    severity: "critical",
  },
  {
    id: "RR003",
    triggerEvent: "Opened Email",
    riskScoreDelta: +5,
    assignedModuleId: "TM005",
    notifyLearner: true,
    notifyManager: false,
    notifyAdmin: false,
    dueDays: 7,
    label: "Email Opened",
    severity: "low",
  },
];

export const remediationStatuses = ["Pending", "In Progress", "Completed", "Overdue"];